<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 class="alert-title" mat-dialog-title>
    <div>{{data.title}}</div>
    <div>{{data.titleRight}}</div>
</h2>
<mat-dialog-content tabindex="-1" class="mat-typography">
    <ng-container *ngIf="data.preContent">
        <div>{{data.preContent}}</div><br>
    </ng-container>
    <div class="larger"><b>{{data.clipboardContent}}</b>
        &nbsp;&nbsp;<button id="{{data.copyButtonId}}" mat-mini-fab (click)="onClick()" color="primary"
                matTooltip="{{data.clickText}}" aria-label="copy to clipboard">
        <span class="mdi mdi-content-copy copy-icon"></span>
      </button>
    </div>
    <ng-container *ngIf="data.postContent">
        <br><div>{{data.postContent}}</div><br>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions class="button-wrapper">
    <button *ngIf="data.showRejectBtn" mat-stroked-button [mat-dialog-close]="false">{{data.rejectBtnName}}</button>
    <button mat-stroked-button [mat-dialog-close]="true">{{data.acceptBtnName}}</button>
</mat-dialog-actions>
